import React from 'react';

const Logo = ({ width = "200px", height = "60px", className = "", style = {} }) => {
  return (
    <img
      src={process.env.PUBLIC_URL + '/logo1.jpg'}
      alt="Digvijay Industries Logo"
      className={`site-logo-img ${className}`}
      style={{
        width: width,
        height: height,
        objectFit: 'contain',
        display: 'block',
        ...style
      }}
    />
  );
};

export default Logo;
